import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<clipPath id=\"a\"><path d=\"M0 0h20v20H0z\"></path></clipPath><g clip-path=\"url(#a)\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.23 18.333H6.186a1.736 1.736 0 0 1-1.736-1.736V3.403a1.736 1.736 0 0 1 1.736-1.736h7.64a1.736 1.736 0 0 1 1.735 1.736v6.57a4.54 4.54 0 0 0-2.083-.044V3.75H6.534v10.418h3.363a4.6 4.6 0 0 0 .153 1.388H9.66a.347.347 0 0 0-.348.348v.694a.347.347 0 0 0 .348.347h.694a.35.35 0 0 0 .263-.12c.405.626.96 1.146 1.614 1.51\" clip-rule=\"evenodd\"></path><circle cx=\"14.428\" cy=\"14.365\" r=\"3.628\" fill=\"#A4A6B6\"></circle></g>", 2)
  ]))]))
}
export default { render: render }